import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** AI template generator — a layout assembling itself, block by block. */
const AiTemplateThumb: React.FC = () => {
  const blocks = [
    { x: 108, y: 96, w: 184, h: 22, begin: '0s' }, // header
    { x: 108, y: 126, w: 88, h: 70, begin: '0.25s' }, // hero left
    { x: 204, y: 126, w: 88, h: 32, begin: '0.5s' }, // right top
    { x: 204, y: 164, w: 88, h: 32, begin: '0.75s' }, // right bottom
    { x: 108, y: 204, w: 120, h: 14, begin: '1s' }, // footer line
    { x: 236, y: 204, w: 56, h: 14, begin: '1.15s' }, // footer line 2
  ];
  return (
    <ThumbFrame label="AI Template Generator">
      {/* Template frame */}
      <rect x="92" y="72" width="216" height="164" rx="12" fill="#ffffff" stroke={INK} strokeWidth="1.8" />

      {/* Generated blocks (fade + rise in sequence) */}
      {blocks.map((b, i) => (
        <rect key={i} x={b.x} y={b.y} width={b.w} height={b.h} rx="5" fill={INK} opacity={i === 0 ? 0.85 : 0.12}>
          <animate attributeName="opacity" values={`0;${i === 0 ? 0.85 : 0.12}`} dur="0.5s" begin={b.begin} fill="freeze" />
        </rect>
      ))}

      {/* AI wand + sparkle */}
      <g>
        <path d="M300 96 l26 -26" stroke={INK} strokeWidth="3" strokeLinecap="round" />
        <path d="M330 60 l2.4 5.2 l5.2 2.4 l-5.2 2.4 l-2.4 5.2 l-2.4 -5.2 l-5.2 -2.4 l5.2 -2.4 Z" fill={INK}>
          <animate attributeName="opacity" values="1;0.4;1" dur="2s" repeatCount="indefinite" />
        </path>
        <path d="M312 84 l1.4 3 l3 1.4 l-3 1.4 l-1.4 3 l-1.4 -3 l-3 -1.4 l3 -1.4 Z" fill={INK} opacity="0.6">
          <animate attributeName="opacity" values="0.6;0.15;0.6" dur="2s" begin="0.5s" repeatCount="indefinite" />
        </path>
      </g>
    </ThumbFrame>
  );
};

export default AiTemplateThumb;
